import React from 'react';
import PromoComboViewer from './PromoComboViewer';

function RogersPricingViewer() {
    return (
        <PromoComboViewer
            apiBase="/api/rogers-pricing-document"
            title="Rogers Pricing"
        />
    );
}

export default RogersPricingViewer;
